import GLightbox from 'glightbox';

export default function init() {
  GLightbox({
    selector: 'product__photos-img'
  })
}